import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/usr/src/app/app/layouts/custom.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/usr/src/app/app/layouts/default.vue").then(m => m.default || m))
}